import styles from "@css/modules/pointsGuide.module.scss"
import { useState } from "react"
import cn from "classnames"
import { Step2Icon1 } from "./step-icons/Step2Icon1"
import { Step2Icon2 } from "./step-icons/Step2Icon2"
import { Step2Icon3 } from "./step-icons/Step2Icon3"
import { Step2Icon4 } from "./step-icons/Step2Icon4"

const list = [
    {
        icon: Step2Icon1,
        text: "Solo / Couple",
        val: [1, 2],
        members: "1-2 members"
    },
    {
        icon: Step2Icon2,
        text: "Small Family",
        val: [3, 4],
        members: "3-4 members"
    },
    {
        icon: Step2Icon3,
        text: "Large Family",
        val: [5, 6],
        members: "5-6 members"
    },
    {
        icon: Step2Icon4,
        text: "Extended Family",
        val: [7, 10],
        members: "7 or more members"
    }
]

export function Step2({ onChange, goNext, goBack, lastValue }) {
    const [value, setValue] = useState(() => lastValue || null)
    const localSetValue = (val) => {
        if (val === value) {
            setValue(null)
            onChange(null)
        } else {
            setValue(val)
            onChange(val)
        }
    }
    const onGoNext = () => {
        if (value) {
            goNext()
        }
    }
    return (
        <div className={styles.stepContainer}>
            <div className={styles.stepContent} id="scroll-target">
                <h2>How many people are typically in your travel party?</h2>
                <div className={styles.stepIcons}>
                    {list.map((i, index) => {
                        const Icon = i.icon
                        return (
                            <button
                                key={index}
                                className={cn({
                                    [styles.stepIconBtn]: true,
                                    [styles.stepIconBtnActive]: i === value
                                })}
                                onClick={() => localSetValue(i)}>
                                <Icon />
                                <div className={styles.btnContent}>
                                    <div className={styles.stepIconText}>{i.text}</div>
                                    <div className={styles.stepIconSub}>{i.members}</div>
                                </div>
                            </button>
                        )
                    })}
                </div>
                <div className={styles.overBackNext}>
                    <button className={styles.goBack} onClick={goBack}>
                        Back
                    </button>
                    <button disabled={!value} className={styles.goNext} onClick={onGoNext}>
                        Continue
                    </button>
                </div>
            </div>
        </div>
    )
}
